<template>
    <div class="common-table">
        <el-row v-if="moreData.hasActionStatus || moreData.hasSearch || moreData.hasActionDate">
            <!-- 状态栏 -->
            <el-col :span="24" style="margin-bottom:10px" v-if="moreData.hasActionStatus">
                <span v-if="moreData.actionLabel" style="color:#409EFF">{{moreData.actionLabel}}：</span>
                <span v-for="item in moreData.actionStatus"
                    class="search-Status"
                    :class="item.statusCode == moreData.defaultSearch ?'active-Status':''"
                    @click="statusChange(item)">{{item.statusName}}
                </span>
            </el-col>
            <!-- 日期栏 -->
            <el-col :span="24" style="margin-bottom:10px" v-if="moreData.hasActionDate">
                <span v-if="moreData.actionDateLabel" style="color:#409EFF">{{moreData.actionDateLabel}}：</span>
                <span v-for="item in moreData.actionDate"
                    class="search-date"
                    :class="item.dateCode == moreData.defaultDateSearch.dateCode ?'active-date':''"
                    @click="dateChange(item)">{{item.dateName}}
                </span>
                <el-date-picker style="width:150px;"
                    v-model="moreData.form1[moreData.filterStartParam]"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd 00:00:00"
                    :picker-options="fileterStartTime(moreData.form1[moreData.filterStartParam],moreData.form1[moreData.filterEndParam])"
                    @change="dateChange1"> 
                </el-date-picker> 至
                <el-date-picker style="width:150px;"
                    v-model="moreData.form1[moreData.filterEndParam]"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd 23:59:59"
                    :picker-options="fileterEndTime(moreData.form1[moreData.filterStartParam],moreData.form1[moreData.filterEndParam])"
                    @change="dateChange2"> 
                </el-date-picker>
            </el-col>
            <!-- 搜索条件 -->
            <el-col :span="24" v-if="moreData.hasSearch">
                <el-form
                    class="search-form"
                    :label-width="labelWidth"
                    ref="aList"
                    :inline="true"
                    :model="moreData.form">
                    <el-row>
                        <slot name="search"></slot>
                        <el-col style="width:300px">
                            <el-button type="primary" 
                                icon="el-icon-search" class="ml-80" 
                                @click="searchBtn">查 询</el-button>
                            <el-button formVisible="true"
                                icon="el-icon-refresh"
                                @click="resuleBtn('aList')">
                                重置
                            </el-button>
                            <el-button
                                @click="addCondition('aList')"
                                v-if="moreData.hasConditionSearch">
                                筛选
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
        </el-row>
        <!-- 分割线 -->
        <div v-if="moreData.hasActionStatus || moreData.hasSearch" class="border-line"></div>
        <!-- 批量操作 -->
        <el-row v-if="moreData.hasActionsMult">
            <el-col :span="24" style="margin-bottom:10px">
                <el-button 
                    plain 
                    type="primary"
                    v-for="item in actionsMult_old"
                    :key="item.actionCode"
                    @click="actionClick(item)"
                    :disabled="item.actionAbled">
                    {{item.actionName}}
                </el-button>
                <span v-for="item in actionsMult_new"
                    :key="item.actionCode">
                    <el-upload
                        action=""
                        :http-request="uploadSectionFile"
                        :show-file-list="false"
                        class="upload-class">
                        </el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </span>
                <span v-if="hasConfig">已选择 {{selectedRows.length}} 条</span> &emsp;
                <span v-if="moreData.tips" style="color:red">{{moreData.tips}}</span> &emsp;
                <span
                    v-if="currFilter.title && currFilter.filterValue"
                    @mouseover="elementBShow" @mouseleave="elementBHidden">
                    筛选条件：
                    <span class="sx-class" v-if="filterText" @click="cancelFilter(currFilter)">
                        {{filterText}}<i style="margin-left:10px" class="el-icon-remove-outline"></i>
                    </span>
                    <span class="sx-class" v-else>{{currFilter.title + ':'+currFilter.filterValue}}</span>
                </span>
            </el-col>
        </el-row>
        <!-- 表格 -->
    
        <!-- showBodyOverflow="title" -->
        <!-- showHeaderOverflow="title" -->
        <u-table 
            border
            ref="plTable"
            @selection-change="onSelectionChange"
            style="width: 100%"
            :use-virtual="rows.length>100"
            :max-height="550"
            :row-height="55"
            :big-data-checkbox="hasConfig"
            :row-style="{height: '0'}"
            :cell-style="{padding: '0',height: '38px'}"
            :header-row-style="{height: '0'}"
            :header-cell-style="headClass">
            <!-- 复选框列 -->
            <u-table-column 
                fixed
                type="selection"
                width="55"
                v-if="hasConfig"
                :key="999999">
            </u-table-column>
            <u-table-column 
                type="index"
                label="序号"
                width="50"
                align="center">
            </u-table-column>
            <!-- 操作 列-->
            <u-table-column width="200"
                label="操作"
                align="center"
                fixed="right"
                v-if="hasHandle"
                :width="moreData.actionsWidth || 200">
                <template slot-scope="scope">
                    <el-button 
                        size="mini" 
                        type="text" 
                        v-for="action in moreData.actions"
                        :key="action.actionCode"
                        @click="actionClick(scope.row,action)"
                        :disabled="(action.actionValue && scope.row[action.actionAbled]) != action.actionValue">
                        {{action.actionName}}
                    </el-button>
                </template>
            </u-table-column>
            <!-- tbody -->
            <u-table-column v-for="(column,index) in columns"
                :key="index"
                :width="column.width"
                :label="column.title"
                :render-header="myHead"
                show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="column.clickAbled" 
                        class="row-click-style"
                        @click="colClick(scope.row)">{{column.dictHandle?column.dictHandle.get(scope.row[column.prop]):scope.row[column.prop]}}</span>
                    <span v-else>{{column.dictHandle?column.dictHandle.get(scope.row[column.prop]):scope.row[column.prop]}}</span> 
                </template>
            </u-table-column>
        </u-table>
        <!-- 分页 -->
        <div class="block" v-if="moreData.hasShowPage">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="moreData[moreData.currPageParam]"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="moreData[moreData.sizePagePaeam]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="moreData.totalPage"
                style="width: 99%;text-align: end;padding: 10px 1%;">
            </el-pagination>
        </div>
        <!-- 筛选框 -->
        <el-dialog
            title="筛选"
            :visible.sync="dialogVisible"
            width="30%">
            <div>
                <div>
                    <div @click="add" style="margin:10px"> 添加条件 </div>
                    <div v-for="item in optionList" style="padding:10px 0">
                        <span>
                            <el-select class="form-class" 
                                v-model="item.title" 
                                placeholder="请选择" 
                                @change="titleChange(item)">
                                <el-option  
                                    v-for="data in columns" 
                                    :key="data.prop"
                                    :label="data.title" 
                                    :value="data.prop">
                                </el-option>
                            </el-select>
                        </span>
                        <span>
                            <el-select class="form-class" 
                                v-model="item.opsValue" 
                                placeholder="请选择" 
                                @change="opsChange(item)">
                                <el-option  
                                    v-for="data in opsList" 
                                    :key="data.value"
                                    :label="data.name" 
                                    :value="data.value">
                                </el-option>
                            </el-select>
                        </span>
                        <span v-if="item.modelType=='text'">
                            <el-input class="form-class" v-model="item.checkValue" placeholder="请输入内容"></el-input>
                        </span>
                        <span v-if="item.modelType=='select'">
                            <el-select 
                                class="form-class" 
                                v-model="item.checkValue" 
                                placeholder="请选择" 
                                @change="opsChange(item)">
                                <el-option  
                                    v-for="data in opsList"
                                    :key="data.prop" 
                                    :label="data.value" 
                                    :value="data.value">
                                </el-option>
                            </el-select>
                        </span>
                        <span v-if="item.modelType=='date'">
                            <el-date-picker
                                v-model="item.checkValue"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                class="margin-b width180">
                            </el-date-picker> 
                        </span>
                        <span v-if="item.modelType=='daterange'">
                            <el-date-picker 
                                style="width:150px;"
                                v-model="item.checkValue"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd 00:00:00"
                                class="margin-b"> 
                            </el-date-picker> 
                            至
                            <el-date-picker 
                                style="width:150px;"
                                v-model="item.checkValue1"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd 23:59:59"
                                class="margin-b"> 
                            </el-date-picker>
                        </span>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="filterBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { newExportExcel } from "./newExport";
export default {
    name: 'JmTable',
    props: ['condition','labelWidth'],
    computed: {
        actionsMult_old: function () {
            return this.moreData.actionsMult.filter(function (item) {
                return item.actionCode != 'upload'
            })
        },
        actionsMult_new: function () {
            return this.moreData.actionsMult.filter(function (item) {
                return item.actionCode == 'upload'
            })
        },
    },
    data() {
        return {
            columns: null,
            rows: [],
            moreData: {},
            sortFlag: false,
            visible: false,  // 是否显示过滤框
            hasConfig: false, // 是否有多选框
            hasHandle: false, // 是否显示操作栏
            selectedRows: [],
            currFilter: {},
            totalPage: 0,
            filterText: '',
            attachments: [],

            optionList: [],
            opsList:[
                {
                    value: "equal",
                    name: '等于'
                },{
                    value: "like",
                    name: '包含'
                },{
                    value: "unequal",
                    name: '不等于'
                },{
                    value: "empty",
                    name: '为空'
                },{
                    value: "notempty",
                    name: '不为空'
                },{
                    value: "between",
                    name: '介于'
                }
            ],
            deafort: {
                title: '',
                opsValue: 'equal',
                checkValue: null,
                checkValue1: null,
                modelType: 'text'
            },
            dialogVisible: false //条件帅选弹框
        }
    },
    methods: {
        init(columns, hasConfig,hasHandle) {
            //初始化表头 是否有多选框，是否有操作栏
            columns.forEach((column) => {
                column.sortOrder = 'none'
                // column.filterValue = ''
            })
            this.$nextTick(() => {
                this.hasConfig = hasConfig
                this.hasHandle = hasHandle
                this.columns = columns
            })    
        },
        load(rows,moreData) {
            //rows为表格数据
            this.$nextTick(() => {
                this.rows = rows //表格body
                this.totalPage = rows.length  // 总页数
                // 设置表格数据
                this.$refs.plTable.reloadData(rows)
                this.moreData = moreData
                if(moreData.hasActionDate) {
                    this.setDefaultDate(moreData.defaultDateSearch)
                }
            })
        },
        myHead(h, { column, $index }, index) {
            // 当有多选框时$index-2列   没有时$index-1
            const cols = this.hasConfig?this.columns[$index-2]:this.columns[$index-1]
            // const cols = this.columns[$index-2]
            return ( 
                <span>
                    <span v-show={cols.sortAbled} 
                        class="sort-class"
                        onClick={() => {this.setSort(cols)}}>
                        <i class="el-icon-caret-top" style={cols.sortOrder=='asc' ? {'color' : '#2779aa'} : {'color': '#999'}}></i>
                        <i class="el-icon-caret-bottom" style={cols.sortOrder=='desc' ? {'color' : '#2779aa'} : {'color': '#999'}}></i>
                    </span>
                    <span v-show={!cols.filterAbled}>{cols.title}</span>
                    <span v-show={cols.filterAbled}>
                        <el-popover
                            placement="bottom"
                            width={cols.popoverWidth?cols.popoverWidth:200}
                            title={cols.title}
                            height="150"
                            trigger="manual"
                            v-model={cols.filterPanelVisible}>
                            <span slot="reference" onClick={() => {this.otherFilter(cols)}}>
                                {cols.title}
                                <i class="el-icon-search" 
                                    style="float: right;margin-top: 5px;cursor: pointer;">
                                </i>      
                            </span> 
                            { this.filterType(cols) }
                            <div class="el-table-filter__bottom" style="margin-bottom: -20px;text-align:center">
                                <el-button type='text' size="mini" onClick={() => {this.search(cols)}}>
                                    筛选
                                </el-button>   
                                <el-button type='text' size="mini" onClick={() => {this.clearSearch(cols)}}>
                                    重置
                                </el-button>  
                                <el-button type='text' size="mini" onClick={() => {cols.filterPanelVisible=false}}>
                                    关闭
                                </el-button>
                            </div>    
                        </el-popover>
                    </span>
                </span>
            )
        },
        // 过滤类型
        filterType(cols) {
            var dom = null
            if (cols.cellRender == 'input') {
                dom = <el-input
                    v-model={cols.filterValue}
                    size="small"
                    placeholder="请输入内容"
                    class="margin-b width180">
                </el-input>;
            } else if(cols.cellRender == 'select') {
                dom = <el-select 
                    v-model={cols.filterValue}
                    placeholder="请选择"
                    class="margin-b width180">
                    {
                        cols.selectOptions.map((item) => {
                            return <el-option label={item.label} value={item.value}>{item.label}</el-option>
                        })  
                    }
                </el-select>  
            } else if(cols.cellRender == 'select-multiple') {
                dom = <el-select 
                    v-model={cols.filterValue}
                    placeholder="请选择"
                    multiple
                    class="margin-b width180">
                    {
                        cols.selectOptions.map((item) => {
                            return <el-option label={item.label} value={item.value}>{item.label}</el-option>
                        })  
                    }
                </el-select>  
            } else if(cols.cellRender == 'date') {
                dom = <el-date-picker
                    v-model={cols.filterValue}
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    class="margin-b width180">
                </el-date-picker> 
            } else if(cols.cellRender == 'daterange') {
                dom = <span>
                    <el-date-picker 
                        style="width:150px;"
                        v-model={cols.filterValue}
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd 00:00:00"
                        class="margin-b"> 
                    </el-date-picker> 
                    至
                    <el-date-picker 
                        style="width:150px;"
                        v-model={cols.filterValue1}
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd 23:59:59"
                        class="margin-b"> 
                    </el-date-picker>
                </span>
            } else if(cols.cellRender == 'radio') {
                dom = <span>
                    {
                        cols.selectOptions.map((item) => {
                            return <el-radio class="margin-b" v-model={cols.filterValue} label={item.value}>{item.label}</el-radio>
                        })  
                    }
                    
                </span>
            }
            return dom
        },
        // 关闭其他过滤弹框
        otherFilter(cols) {
            this.columns.forEach(element => {
                if(element.prop == cols.prop) {
                    cols.filterPanelVisible = !cols.filterPanelVisible 
                }else{
                    element.filterPanelVisible = false
                }
            });
        },
        filterBtn() {
            this.dialogVisible = false
            console.log(this.optionList)
        },
        // search按钮
        searchBtn() {
            // 重置列表头筛选
            this.columns.forEach((column) => {
                if(column.filterAbled) {
                    if(column.cellRender=='daterange') {
                        delete this.condition[column.filterParam1] 
                    }
                    delete this.condition[column.filterParam] 
                }
            })
            const condition = {
                ...this.condition,
                ...this.moreData.form,
                'back': true 
            }
            this.$emit('on-query', condition)
        },
        // 重置按钮
        resuleBtn() {
            this.moreData.form = {}
            this.$emit('resuleBtn',true)
        },
        // 状态筛选操作
        statusChange(action) {
            this.moreData.defaultSearch = action.statusCode 
            // 选中状态查询筛选
            this.condition[this.moreData.filterParam] = action.statusCode 
            this.searchBtn()
        },
        // 日期筛选操作
        dateChange(item) {
            this.moreData.defaultDateSearch = {...item}
            if(item.dateCode != 'ZDY') {
                let g = Number(item.dateCode)
                this.moreData.form1[this.moreData.filterStartParam] = this.getDay(-g)
                this.moreData.form1[this.moreData.filterEndParam] = this.getDay(0) 
                this.condition = Object.assign(this.condition,this.moreData.form1)
                this.searchBtn()
            }
        },
        dateChange1(val) {
            this.moreData.defaultDateSearch = {dateName: '自定义', dateCode: 'ZDY'}
            if(!val) {
                this.moreData.form1[this.moreData.filterStartParam] = ''
            }
            this.$forceUpdate()
        },
        dateChange2(val) {
            this.moreData.defaultDateSearch = {dateName: '自定义', dateCode: 'ZDY'}
            if(!val) {
                this.moreData.form1[this.moreData.filterStartParam] = ''
            }
            this.$forceUpdate()
        },
        // 列表头筛选
        search(cols) {
            // 关闭筛选框
            cols.filterPanelVisible = !cols.filterPanelVisible
            this.columns.forEach((column) => {
                if(column.filterAbled) {
                    if(column.prop !== cols.prop) {
                        column.filterValue = ''
                        if(column.filterValue1) {
                            column.filterValue1 = ''    
                        }
                    }
                    delete this.condition[column.filterParam] 
                }
            })
            // 如果是日期区间
            if(cols.cellRender=='daterange') {
                this.condition[cols.filterParam] = cols.filterValue
                this.condition[cols.filterParam1] = cols.filterValue1 
            }else{
                this.condition[cols.filterParam] = cols.filterValue
            }
            this.currFilter = cols
            this.$emit('on-query', this.condition)
        },
        // 列表头重置
        clearSearch(cols) {
            cols.filterValue = ''
            console.log(cols)
        },
        // 列表头排序
        setSort(column) {
            //排序方法 asc升序 desc降序
            var destOrder = column.sortOrder == 'none'
                    ? 'asc'
                    : column.sortOrder == 'asc'
                    ? 'desc'
                    : column.sortOrder == 'desc'
                    ? 'none'
                    : 'none'
            this.columns.forEach((column) => (column.sortOrder = 'none'))
            column.sortOrder = destOrder
            let array = this.rows.sort(function(a,b){
                return a[column.prop].localeCompare(column.prop)
            })
            this.$nextTick(() => {
                this.rows = array
            })
        },
        // 分页长度
        handleSizeChange(val) {
            this.moreData[this.moreData.sizePagePaeam] = val
            this.condition[this.moreData.sizePagePaeam] = val
            this.$emit('on-query', this.condition)
        },
        // 分页当前页
        handleCurrentChange(val) {
            this.moreData[this.moreData.currPageParam] = val
            this.condition[this.moreData.currPageParam] = val
            this.$emit('on-query', this.condition)
        },
        // 操作按钮
        actionClick(action,row) {
            let obj = {}
            if(row) { // 操作列
                obj = {
                    ...row,
                    action: action
                }
            }else{ // 批量操作
                obj = {
                    selectedRows: [...this.selectedRows],
                    action: action
                }
            }
            if(action.actionCode === 'download') {
                this.exportExcel(action.excelName,action.map)
            }
            this.$emit('action-click', obj)
        },
        // 列点击操作
        colClick(row) {
            this.$emit('col-click', row)
        },
        //多选
        onSelectionChange(selectedRows) {
            this.selectedRows = selectedRows
            this.$emit('selection-change', selectedRows)
        },
        // 导出
        exportExcel(name,map) {
            let exportRecords = [];
            let exportArr = JSON.parse(JSON.stringify(this.rows));
            exportArr.forEach(record => {
                let exportRecord = {};
                for (let [key, value] of map.entries()) {
                    exportRecord[value] = record[key]
                }
                exportRecords.push(exportRecord);
            });
            newExportExcel(name, exportRecords);
        },
        //搜索时间限制
        fileterStartTime (star, end) {
            let _star = star
            return {
                disabledDate(_star) {
                    if (end) {
                        return new Date(end).getTime() <= _star.getTime()
                    }
                }
            }
        },
        fileterEndTime (star, end) {
            let _end = end
            return {
                disabledDate(_end) {
                    if (star) {
                        return _end.getTime() < new Date(star).getTime() - 60*60*24*1000
                    }
                }
            }
        },
        // 日期默认时间段赋值
        setDefaultDate(item) {
            if(item.dateCode != 'ZDY') {
                let g = Number(item.dateCode)
                this.moreData.form1[this.moreData.filterStartParam] = this.getDay(-g)
                this.moreData.form1[this.moreData.filterEndParam] = this.getDay(0) 
                this.condition = Object.assign(this.condition,this.moreData.form1)
            }
        },
        // 相差几天公共方法
        getDay(day){
            var today = new Date();
            var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            if(day == 0) {
                return tYear+"-"+tMonth+"-"+tDate + ' 23:59:59';
            }else{
                return tYear+"-"+tMonth+"-"+tDate + ' 00:00:00';
            }
        },
        doHandleMonth(month){
            var m = month;
            if(month.toString().length == 1){
                m = "0" + month;
            }
            return m;
        },
        // 表头样式设置
        headClass () {
            return 'padding: 0;height: 38px;background:#d7ebf9;color:#2779aa;'
        },
        // 移除筛选条件
        cancelFilter(column) {
            this.currFilter = {}
            this.searchBtn()
        },
        elementBShow() {
            this.filterText = '清除';
        },
        elementBHidden() {
            this.filterText = '';
        },
        // 上传行为，自定义上传请求
        uploadSectionFile(params) {
            //* 1. 图片处理
            const { file } = params
            //* 2. 图片上传
            const fromData = new FormData()
            fromData.append('file', file)
            this.$emit('upload', fromData)
        },
        titleChange(item) {
            item.opsValue = 'equal'
            this.opsChange(item )
        },
        opsChange(item) {
            if(['notempty','empty'].indexOf(item.opsValue)>-1){
                item.modelType = ''
                return
            }
            if(['like','unequal'].indexOf(item.opsValue)>-1){
                item.modelType = 'text'
                return
            }
            if(['between'].indexOf(item.opsValue)>-1){
                item.modelType = 'daterange'
                return
            }
            if(['equal'].indexOf(item.opsValue)>-1){
                const foundedOne = this.columns.find(stu=>stu.prop == item.title);
                if(foundedOne.cellRender === 'daterange') {
                    item.modelType = 'daterange'
                    return
                }else if(foundedOne.cellRender === 'date') {
                    item.modelType = 'date'
                    return
                }else if(foundedOne.cellRender === 'select') {
                    item.modelType = 'select'
                    return
                }else{
                    item.modelType = 'text'
                    return
                }
            }
        },
        // 点击条件帅选按钮
        addCondition() {
            this.dialogVisible = true
            this.optionList.push({...this.deafort}) //添加一个查询条件
        },
        add() {
            this.optionList.push({...this.deafort}) //添加一个查询条件\
        }
    },
    watch: {
        dialogVisible(bull) {
            if(!bull) {
                this.optionList = []
            }
        }
    }
}
</script>
<style>
    .common-table .sort-class {
        float: right;
        cursor: pointer;
        display: inline-flex;
        flex-direction: column;
        position: relative;
        float: right;
        margin: 2px 10px 0 4px;
    }
    .common-table .sort-class .el-icon-caret-top{
        position: absolute;
        top: -1px;
        font-size: 14px;
    }
    .common-table .sort-class .el-icon-caret-bottom{
        position: absolute;
        top: 5px;
        font-size: 14px;
    }
</style>
<style scoped>
    .form-class {
        display: inline-block;
        width: 180px;
        height: 30px;
    }
    .upload-class {
        display: inline-block;
        height: 30px;
        padding: 0 8px;
        line-height: 26px;
        background-color: rgba(64,158,255,.1);
        display: inline-block;
        color: #409EFF;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid rgba(64,158,255,.2);
        margin: 0 6px;
        cursor: pointer;
    }
    .common-table {
        font-size: 13px;
    }
    .margin-b {
        margin-bottom: 20px;
    }
    .width180 {
        width: 194px;
    }
    .row-click-style {
        color: #409eff;
        cursor: pointer;
        text-decoration: underline;
    }
    .search-Status {
        height: 30px;
        padding: 0 8px;
        line-height: 30px;
        background-color: rgba(64,158,255,.1);
        display: inline-block;
        font-size: 12px;
        color: #409EFF;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid rgba(64,158,255,.2);
        margin-right: 4px;
        cursor: pointer;
    }
    .active-Status {
        background-color: #409EFF !important;
        color: #fff !important;
    }
    .search-date {
        height: 30px;
        padding: 0 8px;
        line-height: 30px;
        background-color: rgba(64,158,255,.1);
        display: inline-block;
        font-size: 12px;
        color: #409EFF;
        border-radius: 4px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px solid rgba(64,158,255,.2);
        margin-right: 4px;
        cursor: pointer;
    }
    .active-date {
        background-color: #409EFF !important;
        color: #fff !important;
    }
    .border-line {
        margin-bottom: 8px;
        border-bottom: 1px dashed #ddd;
    }
    .sx-class {
        background-color: #ccc;
        padding: 3px 8px;
        border-radius: 2px;
        cursor: pointer;
        color:#409EFF;
    }
</style>


// WEBPACK FOOTER //
// node_modules/jm-table/src/packages/table/jm-table.vue